module.exports = __webpack_public_path__ + "static/img/back-5-2.b7d95756.png";